import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const fetchEnabledFlagValues = async () => await fetch(
  Config.endpoints.FETCH_ENABLED_FLAG_VALUES
)
  .then(handleErrors({ errorMessage: 'Fetching enabled flag values failed' }))
  .then(parseAsJson);

export const fetchCountryCodes = async () => await fetch(Config.endpoints.FETCH_COUNTRIES)
  .then(handleErrors({ errorMessage: 'Fetching country codes failed' }))
  .then(parseAsJson);

export const fetchAccountCodes = async () => await fetch(Config.endpoints.ACCOUNTS)
  .then(handleErrors({ errorMessage: 'Fetching accounts failed' }))
  .then(parseAsJson);

export const importTaxRates = async (taxRates, periodName) => await fetch(
  Config.endpoints.IMPORT_TAX_RATES,
  {
    method: 'POST',
    body: JSON.stringify(taxRates.map(taxRate => ({
      taxRate,
      ...periodName,
    }))),
  }
)
  .then(handleErrors({ errorMessage: 'Importing Tax Rates failed' }));
